// Reference: https://docs.glia.com/glia-dev/docs/showing-visitor-code
export const injectCobrowseInitiator = () => {
  const gliaVisitorTriggerElement = document.createElement('sm-visitor-code');
  document.body.appendChild(gliaVisitorTriggerElement);
};
